import { Slot } from 'expo-router';
import type { ApplicationStudioToolId } from '../../lib/application-studio-tool-config';

export function ApplicationStudioToolLayout({
  toolId: _toolId,
}: {
  toolId: ApplicationStudioToolId;
}) {
  return (
    <div className="flex flex-1 min-h-0 min-w-0 w-full flex-col">
      <Slot />
    </div>
  );
}
